import { InjectionToken } from '@angular/core';
import { NotificationsOverlayConfig } from './notifications-overlay.service';

export const NOTIFICATIONS_OVERLAY_DATA = new InjectionToken<NotificationsOverlayConfig>('NOTIFICATIONS_OVERLAY_DATA');
